import React from "react";
import { titleCase } from "title-case";
import Typography from "@mui/material/Typography";
import { useIsAdmin } from "./AdminUtil";

const copyText = (text) => {
  navigator.clipboard.writeText(text);
};

const Length = (props) => {
  const value = props.value;
  return parseFloat(value).toFixed(1);
};

const Speed = (props) => {
  const value = props.value;
  if (value === -1) return "N/A";
  else return value;
};

const Location = (props) => {
  var d = props.d;
  var html = props.value;
  const isAdmin = useIsAdmin();

  return (
    <>
      <span dangerouslySetInnerHTML={{ __html: html }} />
      {isAdmin && (
        <div title="Click to Copy">
          <Typography
            variant="body2"
            className="hover-highlight"
            onClick={() => copyText(d.id.trim())}
          >
            <span>{d.id.trim()}</span>
          </Typography>
        </div>
      )}
    </>
  );
};

const Description = (props) => {
  return titleCase(props.value);
};

export { Length, Speed, Location, Description, copyText };
